// The design lock for the table's layout. Every length is a share of the
// card's width (cw), so the table looks the same at every size. A card is
// always 1.4 times as tall as it is wide.

export type LayoutConfig = {
  readonly cardRatio: number
  readonly cardWidth: { readonly min: number; readonly max: number }
  readonly minColumns: number // a table sizes its cards as if it had at least this many columns
  readonly minLongest: number // and as if its longest column held at least this many cards
  readonly pad: { readonly min: number; readonly max: number; readonly ofWidth: number }
  readonly narrowBelow: number // px of window width: a phone
  readonly gap: { readonly wide: number; readonly narrow: number }
  readonly altarRow: number // space between the altars and the columns
  readonly fanForSizing: number // how much of each buried card shows, when sizing
  readonly fan: { readonly wide: number; readonly compact: number; readonly min: number }
  readonly compactBelow: number // px of card width: draw the index marks larger
  readonly smallDeck: number // a rite dealt this few cards sits nearer the middle of the window
  readonly smallDeckSplit: number // ... the room left over is split this many ways, one share above it
  readonly ghostFan: number
  readonly columnMark: { readonly size: number; readonly spread: number; readonly rise: number }
}

export const LAYOUT = {
  cardRatio: 1.4,
  cardWidth: { min: 38, max: 150 },
  minColumns: 4,
  minLongest: 7,
  pad: { min: 10, max: 28, ofWidth: 0.02 },
  narrowBelow: 640,
  gap: { wide: 0.2, narrow: 0.08 },
  altarRow: 0.42,
  fanForSizing: 0.24,
  fan: { wide: 0.3, compact: 0.5, min: 0.12 },
  compactBelow: 76,
  smallDeck: 9,
  smallDeckSplit: 3,
  ghostFan: 0.3,
  columnMark: { size: 0.13, spread: 0.3, rise: 0.36 },
} as const satisfies LayoutConfig
